/* global Ad */

import clearConflictingFormParameters, { hasConflictingParameters } from '@PROJECT_ROOT/assets/desktop/js/search/clearConflictingParameters';
import initDates from '@PROJECT_ROOT/assets/desktop/js/search/private/dates';
import initPersons from '@PROJECT_ROOT/assets/desktop/js/search/private/persons';
import initLocation from '@PROJECT_ROOT/assets/desktop/js/search/private/location';

/**
 * @param {object} state PHP varijable
 */
export default function initPrivateSearchForm(state) {
    initFormState(state);
    initFormEvents(state);
}

function initFormState(state) {
    initDates(state);
    initPersons();
    initLocation(state);

    if (hasConflictingParameters()) {
        // Inicijalno forma može imati postavljene vrijednosti iz cookie-ja pa treba provjeriti konfliktne parametre
        clearConflictingFormParameters();
    }
}

function initFormEvents(state) {
    optimiseUrlOnFormSubmit(state);
    clearConflictingFormParametersOnChange();
}

function optimiseUrlOnFormSubmit(state) {
    document.getElementById('homePagePrivateSearch').addEventListener('submit', (event) => {
        event.preventDefault();
        const ajaxData = Ad.Search.getSearchFormAjaxData('homePagePrivateSearch');
        Ad.Search.fetchOptimalUrlAndRedirect(ajaxData, state.privateQueryOptimiseUrl);
    });
}

function clearConflictingFormParametersOnChange() {
    const privateFormElements = document.querySelectorAll('[id^="SearchPrivateFilterForm"]');
    for (let i = 0; i < privateFormElements.length; i += 1) {
        privateFormElements[i].addEventListener('change', () => {
            if (hasConflictingParameters()) {
                clearConflictingFormParameters();
            }
        });
    }
}
